// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"98b5f5d7","455":"3e918a72","977":"a002fe75"}[chunkId] + ".chunk.js";
};